export const MY_SETTINGS_OPTION = 0;
export const FIRM_SETTINGS_OPTION = 1;
export const INTEGRATIONS_OPTION = 2;
export const MODELS_OPTION = 3;
export const ASSET_CLASSES = 7;
export const CUSTOM_MODEL_ASSUMPTIONS = 8;
export const ASSET_BUCKETING = 9;
export const DATA_FEEDS_SETTINGS_OPTION = 10;
export const TEMPLATES = 11;

export const MENU_OPTIONS = [
  {
    name: 'My Settings',
    id: MY_SETTINGS_OPTION,
    slug: 'MySettings',
  },
  {
    name: 'Firm Settings',
    id: FIRM_SETTINGS_OPTION,
    slug: 'FirmSettings',
  },
  {
    name: 'Data Feeds',
    id: DATA_FEEDS_SETTINGS_OPTION,
    slug: 'DataFeedsSettings',
  },
  {
    name: 'Integrations',
    id: INTEGRATIONS_OPTION,
    slug: 'Integrations',
  },
  {
    name: 'Model Portfolios',
    id: MODELS_OPTION,
    slug: 'ModelPortfolios',
  },
  {
    name: 'Asset Classes',
    id: ASSET_CLASSES,
    slug: 'assetClasses',
  },
  {
    name: 'CMAs',
    id: CUSTOM_MODEL_ASSUMPTIONS,
    slug: 'cmas',
  },
  {
    name: 'Asset Bucketing',
    id: ASSET_BUCKETING,
    slug: 'assetBucketing',
  },
  {
    name: 'Templates',
    id: TEMPLATES,
    slug: 'templates',
  },
];

export const ASSUMPTIONS_DEFINITION = {
  inflationRate: {
    label: 'Inflation Rate (%)',
    type: 'percentage',
  },
  loanBalanceInterestRate: {
    label: 'Loan Balance Interest Rate (%)',
    type: 'percentage',
  },
  monteCarloSimulations: {
    label: 'Monte Carlo Simulations',
    type: 'number',
  },
  incomeGrowthRate: {
    label: 'Income Growth Rate (%)',
    type: 'percentage',
  },
  turnoverRatio: {
    label: 'Turnover Ratio (%)',
    type: 'percentage',
  },
  potentialRevenueRate: {
    label: 'Potential Revenue Rate (%)',
    type: 'percentage',
  },
  socialSecurityInflationRate: {
    label: 'Social Security Inflation Rate (%)',
    type: 'percentage',
  },
  capitalGainsRatio: {
    label: 'Long-Term Capital Gains Ratio (%)',
    type: 'percentage',
  },
  excessCashflowMode: {
    label: 'Excess Cash Flow',
    type: 'select',
    options: [
      { label: 'Spend', value: 0 },
      { label: 'Save', value: 1 },
    ],
  },
  tuitionInflationRate: {
    label: 'Tuition Inflation Rate (%)',
    type: 'percentage',
  },
  lifeExpectancy: {
    label: 'Life Expectancy (years)',
    type: 'age',
  },
  portfolioReturnsMethodology: {
    label: 'Portfolio Returns',
    type: 'select',
    options: [
      { label: 'Weighted Average', value: 0 },
      { label: 'Hypothetical', value: 1 },
    ],
  },
  assumeCurrentTaxRateProvisionsExpire: {
    label: 'Assume Current Tax Provisions Expire',
    type: 'select',
    options: [
      { label: 'Yes', value: true },
      { label: 'No', value: false },
    ],
  },
};

export const managedAccountsGroupingOptions = [
  {
    label: 'None',
    value: false,
  },
  {
    label: 'Portfolio Group',
    value: true,
  },
];
